<div class="sum-overview">
  <div class="sum-entry">
    <h4>{{tripCount}}</h4><br/>
    <h3>{{'dashboard.trip_count' | translate}}</h3>
  </div>
</div>
